import React, { useEffect, useState } from 'react';
import api from '../../config/axios';
import { useNavigate, useLocation } from 'react-router-dom';
import '../order/OrderCreate.css';

interface Table {
  _id: string;
  name: string;
  status: string;
}

const GroupOrderCreate: React.FC = () => {
  const [tables, setTables] = useState<Table[]>([]);
  const [selectedTableId, setSelectedTableId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchTables = async () => {
      try {
        setLoading(true);
        const res = await api.get('/api/tables');
        setTables(res.data.data || res.data);
      } catch (err) {
        setError('Không thể tải danh sách bàn');
      } finally {
        setLoading(false);
      }
    };
    fetchTables();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tid = params.get('tableId');
    if (tid) setSelectedTableId(tid);
  }, [location.search]);

  const handleCreateSession = async () => {
    if (!selectedTableId) {
      setError('Vui lòng chọn bàn');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');

      const res = await api.post('/api/group-orders/create', {
        tableId: selectedTableId
      });

      const { sessionCode, tableName } = res.data.data;
      
      setSuccess(`Đã tạo session nhóm thành công! Session code: ${sessionCode}`);
      
      setTimeout(() => {
        navigate(`/orders/group-order?sessionCode=${sessionCode}&tableId=${selectedTableId}`);
      }, 2000);

    } catch (err: any) {
      setError(err.response?.data?.message || 'Lỗi khi tạo session nhóm');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="order-create-bg">
      <div className="order-create-container">
        <h2 className="order-create-title">TẠO SESSION ĐẶT MÓN NHÓM</h2>
        
        <div style={{ 
          background: '#e6f3ff', 
          border: '1px solid #91d5ff', 
          borderRadius: 8, 
          padding: 16, 
          marginBottom: 24,
          fontSize: 14,
          color: '#1890ff'
        }}>
          <strong>📋 Hướng dẫn:</strong>
          <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
            <li>Chọn bàn để tạo session đặt món nhóm</li>
            <li>Hệ thống sẽ tạo session code 3 số ngẫu nhiên</li>
            <li>Chia sẻ session code cho các thành viên trong nhóm</li>
            <li>Mỗi người có thể đặt món riêng và thanh toán chung</li>
          </ul>
        </div>

        {error && <div className="order-create-message order-create-error">{error}</div>}
        {success && <div className="order-create-message order-create-success">{success}</div>}
        
        <div style={{ marginBottom: 24 }}>
          <h3 style={{ marginBottom: 12, color: '#333' }}>Chọn bàn:</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 12 }}>
            {tables.map(table => (
              <button
                key={table._id}
                onClick={() => setSelectedTableId(table._id)}
                className={`order-create-menu-add-btn ${
                  selectedTableId === table._id ? 'order-create-submit-btn' : ''
                }`}
                style={{
                  padding: '12px',
                  fontSize: '14px',
                  textAlign: 'center',
                  opacity: table.status !== 'available' ? 0.5 : 1,
                  cursor: table.status !== 'available' ? 'not-allowed' : 'pointer'
                }}
                disabled={table.status !== 'available'}
              >
                <div style={{ fontWeight: 'bold' }}>{table.name}</div>
                <div style={{ fontSize: '12px', marginTop: '4px' }}>
                  {table.status === 'available' ? 'Trống' : 
                   table.status === 'in-use' ? 'Đang sử dụng' : 
                   table.status === 'reserved' ? 'Đã đặt' : table.status}
                </div>
              </button>
            ))}
          </div>
        </div>

        {selectedTableId && (
          <div style={{ 
            background: '#f6ffed', 
            border: '1px solid #b7eb8f', 
            borderRadius: 8, 
            padding: 16, 
            marginBottom: 24 
          }}>
            <strong>Bàn đã chọn:</strong> {tables.find(t => t._id === selectedTableId)?.name}
          </div>
        )}

        <button 
          onClick={handleCreateSession} 
          className="order-create-submit-btn" 
          disabled={loading || !selectedTableId}
          style={{ width: '100%', fontSize: '16px', padding: '16px' }}
        >
          {loading ? 'Đang tạo session...' : 'Tạo Session Nhóm'}
        </button>

        <div style={{ marginTop: 24, textAlign: 'center' }}>
          <button 
              onClick={() => navigate(-1)}
              className="order-create-menu-add-btn"
              style={{ marginRight: 12 }}
            >
            Quay lại
          </button>
          <button 
            onClick={() => navigate('/orders/group-join')}
            className="order-create-menu-add-btn"
          >
            Tham gia nhóm
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupOrderCreate; 